import { render } from "./MaterialToggleButton.vue?vue&type=template&id=286a026a&scoped=true"
import script from "./MaterialToggleButton.vue?vue&type=script&lang=js"
export * from "./MaterialToggleButton.vue?vue&type=script&lang=js"

import "./MaterialToggleButton.vue?vue&type=style&index=0&id=286a026a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286a026a"]])

export default __exports__